import { useContextSelector } from 'use-context-selector';

import { AuthContext } from '../contexts/AuthContext';

export function usePremium() {
  const user = useContextSelector(AuthContext, (auth) => auth.user);

  return user?.isPremium;
}
